import { FormGroup } from "@angular/forms";

export function MustNotMatchValidator(controlName: string, notMatchingControlNames: string[], notMatchingValues: string[]) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const notMatchingControls = !notMatchingValues ? notMatchingControlNames.map(x => formGroup.controls[x]) : null;

    if (control.errors) {
      return;
    }

    if ((!notMatchingValues && notMatchingControls.some(x => control.value == x.value))
      || (!!notMatchingValues && notMatchingValues.some(x => control.value == x))) {
      control.setErrors({mustNotMatch: true});
    } else {
      control.setErrors(null);
    }
  }
}
